import React, { useState, useEffect } from 'react'

import './App.css';


import Launcher from './components/Launcher';
import { HashRouter as Router, Switch, Route } from 'react-router-dom';
// import routes from './routes/'


import Home from './components/Index'

import Earn from './components/common/Earn'
import Ways from './components/common/Ways'
import Login from './components/home/Login';
import PointActivity from './components/common/PointActivity';
import CovertPointes from './components/common/ConvertPoints';
import MyReward from './components/common/MyReward';
import CouponCode from './components/common/CouponCode';
import Referral from './components/common/Referral';
import Loading from './components/common/Loading';
import Error from './components/common/Error';
import ReferralDetail from './components/common/ReferralDetail'

import { postUserPoints, trackSharePop } from './Utils/blogs';
import { COPY_OUT } from './components/staticTypes';
import { setCookie, getCookie } from './Utils/cookie'



const App = () => {
  
  const [launcherFlag, setLauncherFlag] = useState(false);

  const [data, setData] = useState({});
  const [loading, setLoading] = useState(true);
  const [email, setEmail] = useState(getCookie('my-email'));

  const [availableCodeCount, setAvailableCodeCount] = useState(-1);
  const [visitorId, setVisitorId] = useState(window.localStorage.getItem('visitorId'));
  
  if (visitorId === null || visitorId === undefined) {
    try {
      if (visitorId === null || visitorId === undefined) {
        setVisitorId(getCookie('_pk_id.1.9b57').split('.')[0]);
      }

    } catch (err) {
      setVisitorId('000000')
    }
  } 
  if (email === null || email === undefined) {
    setEmail('');
  }
  
  

  const switchButton = (flag) => {
    setLauncherFlag(flag);
    if(flag === true){
      if(email!=''){
        postUserPoints(email).then((data) => {
          if (data.code === 200) {
            const result = data.result;
            console.log(result)
            setData(result)
            setAvailableCodeCount(result.availableCodeCount);
            setLoading(false)
          }
        }).catch((err) => {
          console.log(err)
        })

        setTimeout(() => {
          setLoading(false);
        }, COPY_OUT)
      }else{
        setLoading(false)
        console.log('email null')
        return false;
      }

      trackSharePop(
        email,
        visitorId,
        'personal-center'
      ).then((res)=> {
        console.log(res)
      }).catch((err) => {
        console.log(err)
      })
    }else{
      return false;
    }
  }

  const getReward = (res) => {
    setData(res);
    setAvailableCodeCount(res.availableCodeCount)

  }

  return (
    <div className="App">
      <div id="rewards">
        <div className={`pages ${launcherFlag === false ? 'hide' : 'show'}`} >
          <div className="panel-html home-rewards">
            <div className="panel-body">
              <div className="frame-content">
                <div id="container">
                  <div className="wantdo-panel-frame-container wantdo-panel-border-radius-rounded wantdo-theme-light wantdo-panel-enter-done">
                    <div className="wantdo-loading-spinner-container wantdo-content-loading wantdo-loading-spinner-hide">
                      <div className="panel-wrapper wantdo-theme-light wantdo-banner-font-color-light wantdo-collapsed-banner-font-color-light wantdo-panel-card-border-radius-rounded wantdo-button-border-radius-rounded wantdo-input-border-radius-rounded wantdo-button-font-color-light accessibility-nav-mouse">
                        <div className="main-panel-container  ">

                          {
                            loading === true ?
                              <Loading />
                              :
                              <div>
                              <Error  
                                data = { data }
                                email = {email}
                              />
                                
                              <Router>
                                <Switch>
                                  <Route exact path='/'>
                                    <Home
                                      data={data}
                                      onClick={switchButton}
                                      launcherFlag={launcherFlag}
                                      availableCodeCount={availableCodeCount}
                                      email = {email}
                                      visitorId= {visitorId}
                                    />
                                  </Route>
                                  <Route exact path='/ways'>
                                    <Ways
                                      data={data}
                                      onClick={switchButton}
                                      launcherFlag={launcherFlag}
                                      email = {email}
                                      visitorId ={visitorId}
                                    />
                                  </Route>
                                  <Route exact path='/earn'>
                                    <Earn
                                      data={data}
                                      onClick={switchButton}
                                      launcherFlag={launcherFlag}
                                      email = {email}
                                      getReward = {getReward}
                                      visitorId = {visitorId}
                                    />
                                  </Route>

                                  <Route exact path='/rewards-list'>
                                    <PointActivity
                                      data={data}
                                      onClick={switchButton}
                                      launcherFlag={launcherFlag}
                                      email = {email}
                                    />
                                  </Route>
                                  <Route exact path='/convert-points'>
                                    <CovertPointes
                                      data={data}
                                      onClick={switchButton}
                                      launcherFlag={launcherFlag}
                                      email = {email}
                                      visitorId= {visitorId}
                                      getReward = {getReward}
                                    />
                                  </Route>
                                  <Route exact path='/my-reward'>
                                    <MyReward
                                      data={data}
                                      onClick={switchButton}
                                      launcherFlag={launcherFlag}
                                      email = {email}
                                      visitorId = {visitorId}
                                    />
                                  </Route>
                                  <Route exact path='/referral-list'>
                                    <ReferralDetail
                                      data={data}
                                      onClick={switchButton}
                                      launcherFlag={launcherFlag}
                                      email = {email}
                                    />
                                  </Route>
                                  <Route exact path='/coupon-code'>
                                    <CouponCode
                                      data={data}
                                      onClick={switchButton}
                                      launcherFlag={launcherFlag}
                                      email = {email}
                                      visitorId = { visitorId }
                                    />
                                  </Route>
                                  <Route exact path='/referral'>
                                    <Referral
                                      data={data}
                                      onClick={switchButton}
                                      launcherFlag={launcherFlag}
                                      email = {email}
                                      visitorId = { visitorId }
                                    />
                                  </Route>

                                </Switch>
                              </Router>
                            {
                            (JSON.stringify(data) === "{}") === true ?
                                <Login />
                                :
                                ''
                            }
                            </div>
                          }

                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

        </div>
        <div id="reward-button">
          <Launcher launcherFlag={launcherFlag} onClick={switchButton} />
        </div>
      </div>
    </div>
  );
}

export default App;
